import apiUrl from '../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import {
  Validator
} from 'vee-validate'
import moment from 'moment'
import DatePicker from 'vue2-datepicker'
import Loader from './../shared/loader'
import CryptoJS from 'crypto-js'
import printJS from 'print-js'
import Printd from 'printd'
import download from 'downloadjs'
import Pagination from './../shared/pagination'
import { BasicSelect } from 'vue-search-select'
import 'vue-search-select/dist/VueSearchSelect.css'
// import Vue from "vue";
import Vue from "vue";
import JsonExcel from "vue-json-excel";
Vue.component("downloadExcel", JsonExcel);

export default {
  name: 'shipment',
  components: {
    Paginate,
    Pagination,
    DatePicker,
    Loader,
    BasicSelect,
    download
  },
  data() {
    return {
      totalPage: 0,
      totalRows: 0,
      currentPage: 1,
      pageLimit: 10,
      msg: '',
      cancelshipdata: [],
      ShipCancelShow: false,
      errmessage: '',
      selectedprod: [],
      comfirmModal: false,
      cancelshipdetails: [],
      toCheckShowRowIndex: '',
      oneshipdetails: [],
      opened: [],
      shipmentDetails: {},
      cancelshipModal: false,
      // currentPage: 0,
      listShipmentsData: [],
      modalMessageShow: false,
      displayMsg: false,
      successErrorMsg: "",
      pono: "",
      shipmentno: "",
      fromDateFlt: "",
      toDateFlt: "",
      newActionMsg: "",
      modelMessage: "",
      // totalPage: 0,
      // pageNo: 0,
      activeClass: 'btn-success',
      warningClass: 'btn-warning',
      showinvoicemodal: false,
      clientdata: [],
      resultCount: '',
      listClientData: [],
      listWarehouseData: [],
      clientid: '',
      client: '',
      warehouseid: '',
      warehouse: '',
      ClientErr: '',
      WarehouseErr: '',
      ClientErr: '',
      searchFlag: false,
      showSelectWarehouse: false,
      showSelectClient: false,
      orderCancelShow: false,
      cancelOrderId: '',
      loginuserid: '',
      shipmentstatuslist: [],
      searchstatus: '',
      isLoading: false,
      displayCancel: false,
      perPage: 10,
      formattedDate: '',
      searchchannel: '',
      channellist: [],
      listShipmentsDataCsv: [],
      orderno: '',
      cancelshipmentFlag: false,
      listMerchantData: [],
      MerchantList: [],
      merchantid: '',
      merchant: '',
      item: {
        value: '',
        text: ''
      },
      listMerchantData1: [{ value: '', text: this.$t('common.selectMerchantPlaceHolder') }],
      csvFieldsForXls: {},
      download: true,
      reportname: '',
      show: false,
      dataFilter2: '',
      listReportDataforxls: [],
      isLoadingforxls: false,
    }
  },

  filters: {
    moment: function (date) {
      return moment(date).format('DD-MM-YYYY');
    }
  },
  mounted() {
    this.calldateFunction();
    this.listClientData = '';
    var permissionEncrypt = window.localStorage.getItem('userdetail');
    var bytes = CryptoJS.AES.decrypt(permissionEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);

    var innerpermissionEncrypt = window.localStorage.getItem('innerpermissiondata')
    var innerbytes = CryptoJS.AES.decrypt(innerpermissionEncrypt.toString(), 'Key');
    var innerplaintext = innerbytes.toString(CryptoJS.enc.Utf8);
    var innerdetail = JSON.parse(innerplaintext);
    this.getComponentPermission(innerdetail);
    this.reportname = this.$t('editedjson.shipmentreport')
    this.reportname = this.reportname + moment().format('DD-MM-YY_HH-mm-ss') + '.xls';
    var roleids = userdetail.roleid.split(',');
    for (var i = 0; i < roleids.length; i++) {
      if (roleids[i] == 40) {
        this.purchasingManager = parseInt(userdetail.roleid);
        this.isTrue = true;
      }
    }
    this.loginuserid = userdetail.userid;
    var loginuseremail = userdetail.email;
    this.pageNo = 0;
    var today = new Date();
    this.formattedDate = moment(today).format('DD/MM/YYYY HH:mm:ss')
    // User access conditions
    if (userdetail.roleid == 1 || userdetail.roleid == 4) {
      this.displayCancel = true
    }
    this.client = window.localStorage.getItem('selectedClient')
		this.warehouse = window.localStorage.getItem('selectedWarehouse')
		this.warehouseid= this.warehouse
		this.clientid =this.client
    if (localStorage.getItem("selectedClient")!='undefined')
		{
		this.getMerchantList();
    this.getSalesChannels();
    this.getStatus();
    }
    this.user_type = userdetail.utype;
    switch (this.user_type) {
      case 'system_user':
        this.showSelectClient = true;
        this.showSelectWarehouse = true;
        // this.getClientList();
        // this.getWarehouseList();
        break;

      case 'client_user':
        this.clientid = userdetail.clientid;
        this.client = this.clientid;
        // this.getWarehouseList();
        this.merchantList();
        this.showSelectWarehouse = true;
        break;

      case 'warehouse_user':
        this.loginUserEmail = userdetail.email;
        this.warehouseid = userdetail.warehouseid;
        this.warehouse = this.warehouseid;
        this.showSelectClient = true;
        // this.getClientList();
        var roleids = userdetail.roleid.split(',');
        for (var i = 0; i < roleids.length; i++) {
          if (roleids[i] == 40) {
            this.purchasingManager = parseInt(roleids[i]);
          }
          if (roleids[i] == 41) {
            this.isInwardUserForPO = true;
          }
        }
        break;

      default:
        this.$alertify.error(this.$t('common.unauthorisedError'));
        break
    }

  }, // End computed
  methods: {
    reset() {
      this.item = {}
    },
    onSelect(item) {
      // select option from parent component
      this.item = item
      this.merchant = item.value;

    },
    dateFormat(date) {
      if (!date) return '';
      return moment(date).format('DD-MM-YY HH:mm:ss');
    },
    dateFormatFRT(date) {
      if (!date) return '';
      return moment(date).format('DD-MM-YY HH:mm:ss');
    },
    dateFormat1(date) {
      if (!date) return '';
      return moment(date).format('YYYY-MM-DD') + " 00:00:00";
    },
    dateFormat2(date) {
      if (!date) return '';
      return moment(date).format('YYYY-MM-DD') + " 23:59:59";
    },
    reasons(data) {
      if (!data) return '';
      var a = ''
      if (data.charAt(0) == "S") {
        return a = data.slice(0, 30);
      }
      return a = data.slice(0, 25);
    },

    time() {
      var self = this
      this.datenow = moment().format()
      setInterval(self.time, 1000)
    },

    getComponentPermission(innerdetail) {
      var component = 'shipment';
      var innerpermArr = {};

      for (var i = 0; i < innerdetail.length; i++) {
        if (innerdetail[i].controllerurl == component) {
          innerpermArr = innerdetail[i].permission;
          break;
        }
      }

      if (JSON.stringify(innerpermArr) == 'null') {
        //alert("wrong");
      }
      else {
        for (var i = 0; i < innerpermArr.length; i++) {
          if (innerpermArr[i].id == 'cancel') {
            this.cancelshipmentFlag = true;
          }
        }
      }


    },
    calldateFunction: function () {
      this.currentDate = new Date().toJSON().slice(0, 10).replace(/-/g, '/');
      this.toDateFlt = this.currentDate;
      var dt = new Date(this.currentDate);
      dt.setDate(dt.getDate() - 7);
      this.fromDateFlt = dt;
    },


    getSalesChannels() {
      let userToken = window.localStorage.getItem('userToken');
      let myStr = userToken.replace(/"/g, '');

      if (this.clientid == '') {
        this.WarehouseErr = this.$t('srReport.clientError') ;
        return false;
      }
      axios({
        method: 'POST',
        'url': apiUrl.api_url + 'orderSalesChannelList',
        'data': {
          clientid: this.clientid
        },
        headers: {
          'Authorization': 'Bearer ' + myStr,
        }
      })
        .then(result => {
          this.channellist = result.data.data;
        }, error => {
          console.error(error);
        });
    },

    getStatus() {
      let userToken = window.localStorage.getItem('userToken');
      let myStr = userToken.replace(/"/g, '');
      this.shipmentstatuslist = [];
      if (localStorage.getItem("selectedClient") == '') {
        this.WarehouseErr = this.$t('common.clientError') ;
        return false;
      }
      axios({
        method: 'POST',
        'url': apiUrl.api_url + 'statusList',
        'data': {
          clientid: localStorage.getItem("selectedClient")
        },
        headers: {
          'Authorization': 'Bearer ' + myStr,
        }
      })
        .then(result => {
          for (var i = 0; i < result.data.length; i++) {
            if (result.data[i].status_name) {
              this.shipmentstatuslist.push({
                status_name: result.data[i].status_name
              });
            }
          }
        }, error => {
          console.error(error);
        });
    },

    // getClientList() {
    //   this.listClientData = '';
    //   this.pageno = 0;

    //   if (window.localStorage.getItem("clientList") !== null) {
    //     var clientListEncrypt = window.localStorage.getItem('clientList');
    //     var clientbytes = CryptoJS.AES.decrypt(clientListEncrypt.toString(), 'Key');
    //     var plaintextclient = clientbytes.toString(CryptoJS.enc.Utf8);
    //     this.listClientData = JSON.parse(plaintextclient);
    //   } else {

    //     var userToken = window.localStorage.getItem('userToken');
    //     var myStr = userToken.replace(/"/g, '');
    //     if (this.warehouseid)
    //       this.input = ({
    //         warehouseid: this.warehouseid,
    //       });
    //     else {
    //       this.input = {};
    //     }

    //     axios({
    //       method: 'POST',
    //       'url': apiUrl.api_url + 'getWarehouseAssociatedClientList',
    //       'data': this.input,
    //       headers: {
    //         'Authorization': 'Bearer ' + myStr,
    //       }
    //     })
    //       .then(result => {
    //         this.listClientData = result.data.data;
    //       }, error => {
    //         console.error(error);
    //       });
    //   }
    // },

    // getWarehouseList() {
    //   this.pageno = 0;

    //   if (window.localStorage.getItem("warehouseList") !== null) {
    //     var warehouseListEncrypt = window.localStorage.getItem('warehouseList');
    //     var warehousebytes = CryptoJS.AES.decrypt(warehouseListEncrypt.toString(), 'Key');
    //     var plaintextwarehouse = warehousebytes.toString(CryptoJS.enc.Utf8);
    //     this.listWarehouseData = JSON.parse(plaintextwarehouse);
    //   } else {

    //     var userToken = window.localStorage.getItem('userToken')
    //     var myStr = userToken.replace(/"/g, '');
    //     this.input = ({
    //       clientid: this.clientid,
    //     });

    //     axios({
    //       method: 'POST',
    //       'url': apiUrl.api_url + 'getClientAssociatedWarehouseList',
    //       'data': this.input,
    //       headers: {
    //         'Authorization': 'Bearer ' + myStr
    //       }
    //     })
    //       .then(result => {
    //         this.listWarehouseData = result.data.data;
    //       }, error => {
    //         console.error(error)
    //       })
    //   }
    // },
    // clientSelected() {
    //   if (this.clientid != this.client) {
    //     this.clientid = this.client;
    //     this.getMerchantList();
    //     this.merchant = '';
    //     if (this.clientid)
    //       this.getSalesChannels();
    //     this.getStatus();
    //     if (this.user_type != 'warehouse_user') {
    //       this.listWarehouseData = []
    //       this.getWarehouseList();
    //       if (this.listWarehouseData.find(entry => entry.warehouseid === this.warehouse)) {
    //         this.warehouse = this.warehouseid = '';
    //       } else {
    //         this.warehouse = ''
    //       }
    //     } else {
    //       if (this.warehouseid && this.clientid) {
    //         //this.getOrderList();
    //       }
    //     }
    //   }
    //   this.totalRows = 0
    //   this.listShipmentsData = [];
    //   this.pageno = this.totalPage = 0;
    // },

    // warehouseSelected() {
    //   this.warehouseid = this.warehouse;
    //   this.pageno = this.totalPage = 0;
    //   if (this.warehouseid) {
    //     if (this.clientid) {
    //       this.getSalesChannels();
    //       this.getStatus();
    //     } else {
    //       this.getClientList();
    //     }
    //   }
    // },
    getshimentSearch() {
      this.currentPage = 1;
      this.totalPage = 0;
      this.resultCount = 0;
      this.searchFlag = true;
      this.getShipmentList();
    },
    jsonToCSV(filename, data, csvfield, dateFilder = [], skipFilter = []) {
      var csvData = ''
      //Header
      if (this.title != null) {
        csvData += this.parseExtraData(this.title, '${data}\r\n')
      }
      //Fields
      for (let key in data[0]) {
        csvData += csvfield[key] + ','
      }
      csvData = csvData.slice(0, csvData.length - 1)
      csvData += '\r\n'
      //Data
      data.map(function (item) {
        for (let key in item) {
          // cast Numbers to string
          if (key == "transactiontodate") {
            var escapedCSV = moment(item[key]).format('DD-MM-YY HH:mm:ss') + '' // cast Numbers to string
          } else if (key == "transactiontodate") {
            var escapedCSV = moment(item[key]).format('DD-MM-YY HH:mm:ss') + '' // cast Numbers to string
          } else if (key == "transactionfromdate") {
            var escapedCSV = moment(item[key]).format('DD-MM-YY HH:mm:ss') + '' // cast Numbers to string
          } else {
            var escapedCSV = item[key] + '' // cast Numbers to string
          }
          if (escapedCSV.match(/[,"\n]/)) {
            escapedCSV = '"' + escapedCSV.replace(/\"/g, "\"\"") + '"'
          }
          if (escapedCSV == 'null')
            csvData += ',';
          else {
            if (dateFilder.indexOf(key) != -1)
              csvData += moment(escapedCSV).format('DD-MM-YY HH:mm:ss') + ','
            else
              csvData += escapedCSV + ','
          }
        }
        csvData = csvData.slice(0, csvData.length - 1)
        csvData += '\r\n'
      })
      //Footer
      if (this.footer != null) {
        csvData += this.parseExtraData(this.footer, '${data}\r\n')
      }
      filename += moment().format('DD-MM-YY-HH-mm-ss') + '.csv';
      return this.export(csvData, filename, "application/csv");
      return csvData
    },
    export(data, filename, mime) {
      let blob = this.base64ToBlob(data, mime)
      download(blob, filename, mime)
    },
    base64ToBlob(data, mime) {
      let base64 = window.btoa(window.unescape(encodeURIComponent(data)))
      let bstr = atob(base64)
      let n = bstr.length
      let u8arr = new Uint8ClampedArray(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new Blob([u8arr], {
        type: mime
      })
    },
    getShipmentList(csvCheck = 0) {
      if (csvCheck !== 1) {
        this.download = true;
        this.show = false;

      }

      if (csvCheck == 2) {
        this.show = false;
        this.download = true;
        this.limitExeed = false;
      }
      var dataFilter = {};
      let userToken = window.localStorage.getItem('userToken')
      let myStr = userToken.replace(/"/g, '');
      if (this.fromdate != "") {
        this.fromdate = this.dateFormat(this.fromdate) + " 00:00:00";
      }
      if (this.todate != "") {
        this.todate = this.dateFormat(this.todate) + " 23:59:59";
      }
      if (localStorage.getItem("selectedClient") == 'undefined' || localStorage.getItem("selectedClient") =='') {
				this.$alertify.error(this.$t('common.clientError'))
        this.pageNo = this.totalPage = 0;
        this.listShipmentsData = [];
        return false;
      }
      if (localStorage.getItem("selectedWarehouse") == 'undefined' || localStorage.getItem("selectedWarehouse")=='') {
				this.$alertify.error(this.$t('common.warehouseError'))
        this.pageNo = this.totalPage = 0;
        this.listShipmentsData = [];
        return false;
      }
      //this.totalRows=0;
      this.isLoading = true;
      this.input = ({
        offset: (this.currentPage - 1) * 10,
        limit: this.pageLimit,
        shipmentno: this.shipmentno.trim(),
        fromDateFlt: this.dateFormat1(this.fromDateFlt),
        toDateFlt: this.dateFormat2(this.toDateFlt),
        warehouseid: window.localStorage.getItem("selectedWarehouse"),
        clientid: localStorage.getItem("selectedClient"),
        searchstatus: this.searchstatus,
        searchchannel: this.searchchannel,
        csvData: csvCheck,
        orderno: this.orderno.trim(),
        merchantid: this.merchant,
      });

      axios({
        method: 'POST',
        'url': apiUrl.api_url + 'shipmentList',
        'data': this.input,
        headers: {
          'Authorization': 'Bearer ' + myStr
        }
      })
        .then(result => {
          if (csvCheck == 1) {
            this.csvFields = {
              'poid': this.$t('removeHold.poId'),
              '_id': this.$t('common.shipmentId'),
              'status_name': this.$t('common.status'),
              'order_no': this.$t('orders.orderNum'),
              'created_at': this.$t('common.createdDate'),
              'channel_name': this.$t('common.salesChannel'),
              'totalitem': this.$t('inwardList.printData.totalSKU'),
              'totalquantity': this.$t('common.totalQTY'),
              'reasons': this.$t('shipment.rejectedReasons'),
              'merchantname': this.$t('common.merchantName'),

            };
            var dateFilder = [];
            var skipFilter = [];
            this.listShipmentsDataCsv = result.data.data;
            this.jsonToCSV(this.$t('editedjson.shipment'), this.listShipmentsDataCsv, this.csvFields, dateFilder, skipFilter);

          } else {
            if (result) {
              this.listShipmentsData = result.data.result
              this.totalRows = result.data.totalRows;
              for (var i = 0; i < this.listShipmentsData.length; i++) {
                this.listShipmentsData[i].contentVisible = false;
              }

              if (result.data.errorCode == -1) {
                this.resultCount = 0;
              } else {
                this.totalRows = result.data.totalRows;
                this.resultCount = result.data.totalRows;
                if (this.totalRows > 0) {
                  if (this.totalRows <= this.pageLimit) {
                    this.totalPage = 1;
                  } else {
                    this.totalPage = Math.ceil(this.totalRows / this.pageLimit);
                  }
                }
              }
            }
          }
          this.isLoading = false;
        }, error => {
          console.error(error);
        })
    },
    Choosetype() {
      this.show = true;
      this.download = false;
      this.getPickingreportDataForXls(3)
    },
    startDownload() {
      this.isLoadingforxls = true;
    },
    finishDownload() {
      this.isLoadingforxls = false;
    },
    getPickingreportDataForXls(csvCheck = 0) {

      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');
      this.show = true;
      this.download = false;
      this.dataFilter2 = [];
      var value = '';
      var str = '';
      var fr_date = '';
      var to_date = '';
      var frstatus_date = '';
      var tostatus_date = '';
      // this.ClientErr = '';
      this.input = ({
        offset: (this.currentPage - 1) * 10,
        limit: this.pageLimit,
        shipmentno: this.shipmentno.trim(),
        fromDateFlt: this.dateFormat1(this.fromDateFlt),
        toDateFlt: this.dateFormat2(this.toDateFlt),
        warehouseid: window.localStorage.getItem("selectedWarehouse"),
        clientid: localStorage.getItem("selectedClient"),
        searchstatus: this.searchstatus,
        searchchannel: this.searchchannel,
        csvData: csvCheck,
        orderno: this.orderno.trim(),
        merchantid: this.merchant,
      })
      Object.entries(this.input).forEach(([k, v]) => {
        let skipkeys = ['offset', 'limit', 'csvData'];
        if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
          value += k + ':' + v + ','
          this.dataFilter2 = str.concat(value);

        }
      })
      axios({
        method: 'POST',
        'url': apiUrl.api_url + 'shipmentList',
        'data': this.input,
        headers: {
          'Authorization': 'Bearer ' + myStr
        }
      })
        .then(result => {
          if (csvCheck == 3) {
            if (result.data.data.length > 0) {
              this.listReportDataforxls = [];
              this.csvFieldsForXls[this.$t('removeHold.poId')] = 'poid';
              this.csvFieldsForXls[this.$t('common.shipmentId')] = '_id';
              this.csvFieldsForXls[this.$t('common.status')] = 'status_name';
              this.csvFieldsForXls[this.$t('orders.orderNum')] = 'order_no';
              this.csvFieldsForXls[this.$t('common.createdDate')] = 'created_at';
              this.csvFieldsForXls[this.$t('common.salesChannel')] = 'channel_name';
              this.csvFieldsForXls[this.$t('inwardList.printData.totalSKU')] = 'totalitem';
              this.csvFieldsForXls[this.$t('common.totalQTY')] = 'totalquantity';
              this.csvFieldsForXls[this.$t('shipment.rejectedReasons')] = 'reasons';
              this.csvFieldsForXls[this.$t('common.merchantName')] = 'merchantname';
              this.listReportDataforxls = result.data.data;
            } else {
              if (result.data.status == true) {
                this.$alertify.success(this.$t('common.reportSizeError'));
              } else {
                this.$alertify.error(result.data.msg.message);
              }
            }
          }
        },
          error => {
            console.error(error)
          })
    },
    // getPaginationData(currentPage) {
    //   this.pageNo = (currentPage - 1) * this.perPage;
    //   this.getShipmentList()
    // },
    onPageChange(page) {
      this.currentPage = page;
      this.getShipmentList()
    },
    getShipmentSearch() {
      this.pageNo = 0;
      this.totalPage = 0;
      this.resultCount = 0;
      this.searchFlag = true;
      this.getShipmentList();
    },
    resetOrderSearch() {
      this.item = {
        value: '',
        text: ''
      };
      // this.listMerchantData1 = [{ value: '', text: this.$t('common.merchantPlaceholder') }];
      this.orderno = '';
      this.searchchannel = '';
      this.shipmentno = '';
      this.fromDateFlt = "";
      this.merchant = '';
      // this.clientid = '';
      this.toDateFlt = "";
      this.searchstatus = '';
      this.totalRows = 0;
      this.listShipmentsData = [];
      this.pageNo = 0;
      this.totalPage = 0;
      this.resultCount = 0;
      this.searchFlag = false;
      this.download = true;
      // if (this.user_type == 'warehouse_user')
      //   this.client = '';
      // else if (this.user_type == 'client_user')
      //   this.warehouse = '';
      // else {
      //   this.client = '';
      //   this.warehouse = '';
      // }
    },
    //validate all form fields on onsubmit()
    onSubmit: function () {
      this.$validator.validateAll().then(() => {
        console.log('form is valid', this.model)
      }).catch(() => {
        console.log('errors exist', this.errors)
      });
    },
    cancelBtn(data) {
      this.shipmentDetails = {}
      this.cancelshipdetails = []
      this.selectedprod = []
      for (var i = 0; i < data.productid.length; i++) {
        this.cancelshipdetails.push({
          "shipmentid": data._id,
          "orderid": data.poid,
          "productid": data.productid[i],
          "mrp": data.mrp[i],
          "qty": data.qty[i],
          "productname": data.productname[i],
          "itemid": data.itemid[i],
          "status": data.prodstatus[i]
        })
      }
      this.shipmentDetails = data
      this.cancelshipModal = true
    },
    closeshipModal() {
      this.cancelshipModal = false;
    },
    cancelprodlist() {

      if (this.selectedprod.length <= 0) {
        this.errmessage = this.$t('shipment.selectProductToCancel');
        return false;
      } else {
        this.errmessage = '';
      }
      this.comfirmModal = true;
    },
    closeConfirm() {
      this.comfirmModal = false;
      this.cancelshipModal = false;
    },

    showRow(data) {
      this.toCheckShowRowIndex = Number(this.listShipmentsData.indexOf(data))
      for (var i = 0; i < this.listShipmentsData.length; i++) {
        if (this.listShipmentsData[i].contentVisible == true && i != this.toCheckShowRowIndex) {
          this.listShipmentsData[i].contentVisible = false
        }
      }
      this.oneshipdetails = []
      for (var i = 0; i < data.productid.length; i++) {
        this.oneshipdetails.push({
          "productid": data.productid[i],
          "mrp": data.mrp[i],
          "qty": data.qty[i],
          "productname": data.productname[i],
          "status": data.prodstatus[i]
        })
      }
      data.contentVisible = !data.contentVisible;
      const index = this.opened.indexOf(data.tripid);
      if (index > -1) {
        this.opened.splice(index, 1)
      } else {
        this.opened = []
        this.opened.push(data.tripid)
      }
    },
    cancelConfim() {
      var userToken = window.localStorage.getItem('userToken');
      var myStr = userToken.replace(/"/g, '');
      // this.cancelshipdetails
      var itemid = []
      var productid = []
      for (var j = 0; j < this.selectedprod.length; j++) {
        for (var i = 0; i < this.cancelshipdetails.length; i++) {
          if (this.cancelshipdetails[i].itemid == this.selectedprod[j]) {
            itemid[j] = this.cancelshipdetails[i].itemid
            productid[j] = this.cancelshipdetails[i].productid
          }
        }
      }
      this.input = {
        "clientid": localStorage.getItem("selectedClient"),
        "warehouseid": window.localStorage.getItem("selectedWarehouse"),
        "userid": this.loginuserid,
        "orderid": this.cancelshipdetails[0].orderid,
        "shipmentid": this.cancelshipdetails[0].shipmentid,
        "productid": productid,
        "itemid": itemid,
      }
      axios({
        method: 'POST',
        'url': apiUrl.api_url + 'markShipmentCancel',
        'data': this.input,
        headers: {
          'Authorization': 'Bearer ' + myStr,
        }
      })
        .then(result => {
          if (result.data.data.ErrorCode == 0) {
            this.$alertify.success(result.data.data.msg);
            this.comfirmModal = false;
            this.cancelshipModal = false;
            this.getPaginationData(this.currentPage);
          } else {
            this.$alertify.error("Failed");
            this.comfirmModal = false;
            this.cancelshipModal = false;
          }
        }, error => {
          console.error(error);
          this.comfirmModal = false;
          this.cancelshipModal = false;
          this.$alertify.error(this.$t('inwardList.somethingWentWrong'));
        });
    },
    // this below function is for whole shipment cancel
    cancelFullShipm() {
      var userToken = window.localStorage.getItem('userToken');
      var myStr = userToken.replace(/"/g, '');
      this.orderShipShow = false;
      if (localStorage.getItem("selectedClient") == '') {
        this.$alertify.error(this.$t('common.clientMsg'));
        return false;
      }
      this.input = {
        "clientid": localStorage.getItem("selectedClient"),
        "warehouseid": window.localStorage.getItem("selectedWarehouse"),
        "userid": this.loginuserid,
        "orderid": this.cancelshipdata.order_no,
        "shipmentid": this.cancelshipdata._id,
      }
      axios({
        method: 'POST',
        'url': apiUrl.api_url + 'markShipmentCancel',
        'data': this.input,
        headers: {
          'Authorization': 'Bearer ' + myStr,
        }
      })
        .then(result => {
          if (result.data.data.ErrorCode == 0) {
            this.ShipCancelShow = false;
            this.$alertify.success(result.data.data.msg);
            this.getPaginationData(this.currentPage);
          } else {
            this.$alertify.error(this.$t('orders.failed'));
            this.ShipCancelShow = false;
            this.getPaginationData(this.currentPage);
          }
        }, error => {
          console.error(error);
          this.$alertify.error(this.$t('inwardList.somethingWentWrong'));
        });
    },
    isshow(data) {
      document.getElementById(data._id).innerHTML = data.reason
    },
    isshow1(data) {
      document.getElementById(data._id).innerHTML = this.reasons(data.reason)
    },
    getMerchantList() {
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');
      this.input = ({
        clientid: localStorage.getItem("selectedClient"),
      })
      axios({
        method: 'POST',
        'url': apiUrl.api_url + 'merchantList',
        'data': this.input,
        headers: {
          'Authorization': 'Bearer ' + myStr
        }
      })
        .then(result => {
          if (result.data && result.data.length > 0) {
            this.listMerchantData = result.data;
            var merchantListArray = [];
            result.data.forEach(function (item) {
              merchantListArray[item.merchantid] = item.merchantname;
            });
            this.merchantList = merchantListArray;
            this.item = {
              value: '',
              text: ''
            },
              this.listMerchantData1 = [{ value: '', text: this.$t('common.selectMerchantPlaceHolder') }]
            this.listMerchantData.forEach(ele => {
              this.listMerchantData1.push({
                "value": ele.merchantid,
                "text": ele.merchantname

              })
            })
          }
        }, error => {
          console.error(error)
        })
    },

  } // end methods

}



// WEBPACK FOOTER //
// ./src/views/components/shipment/shipment.component.js